<template>
  <div class="login-box">
    <b-button v-if="!isLoggedIn" class="btn-link" v-on:click="showLogin">
      <font-awesome-icon icon="sign-in-alt" />
      <span class="d-none d-sm-inline-block pl-1">&nbsp;Ingresar</span>
    </b-button>
    <span class="d-none d-md-inline-block" v-if="isLoggedIn">Bienvenido(a) {{ loggedInName }}</span>
    <b-button v-if="isLoggedIn" class="btn-link" v-on:click="logout">
      <font-awesome-icon icon="sign-out-alt" />
      <span class="d-none d-lg-inline-block pl-1">&nbsp;Salir</span>
    </b-button>
  </div>
</template>

<script>
import { library } from "@fortawesome/fontawesome-svg-core";
import { faSignInAlt, faSignOutAlt } from "@fortawesome/free-solid-svg-icons";
library.add(faSignInAlt, faSignOutAlt);

export default {
  name: "LoginBox",
  computed: {
    isLoggedIn: function() {
      return this.$store.getters.isLoggedIn;
    },
    loggedInName: function() {
      return this.$store.getters.loggedInName;
    }
  },
  methods: {
    showLogin: async function() {
      const self = this;
      await this.$swal({
        title: "Ingresa aquí para participar",
        html:
          '<input id="membership" class="swal2-input" placeholder="Número de membresía">' +
          '<input id="password" class="swal2-input" type="password" placeholder="Contraseña">',
        focusConfirm: false,
        preConfirm: () => {
          const membership = self.$swal.getPopup().querySelector("#membership")
            .value;
          const password = self.$swal.getPopup().querySelector("#password")
            .value;
          if (membership === "" || password === "") {
            self.$swal.showValidationMessage(
              `Por favor ingrese un usuario y contraseña`
            );
          }
          return { membership: membership, password: password };
        },
        showCancelButton: true,
        confirmButtonText: "Ingresar",
        cancelButtonText: "Cancelar"
      })
        .then(function(result) {
          if (result.dismiss !== undefined) {
            return;
          }

          self.$store.dispatch("login", result.value).catch(err =>
            self.$swal({
              title: "Error",
              text: err,
              icon: "error"
            })
          );
        })
        .catch(self.$swal.noop);
    },
    logout: function() {
      this.$store.dispatch("logout");
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/scss/partial";

.login-box {
  button,
  a {
    color: $red;
    font-weight: 700;
    font-size: 1.5rem;

    @media (max-width: prev-viewport-max-size("sm")) {
      font-size: 2rem;
    }
  }
}
</style>
